<div class="optional">
    <span triggers="manual" container="body" placement="right" class="optional-text">
        <span [innerHTML]="typeConfig.label"></span>
    </span>
</div>
